import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=a5702c1a&scoped=true&"
import script from "./SidebarItem.vue?vue&type=script&lang=ts&"
export * from "./SidebarItem.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=a5702c1a&prod&lang=scss&"
import style1 from "./SidebarItem.vue?vue&type=style&index=1&id=a5702c1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5702c1a",
  null
  
)

export default component.exports